<script>
  import editorialContent from "../Api";
  import { operationStore, query } from "@urql/svelte";
  import clsx from "clsx";

  export let categoryId;
  export let location;
  export let showCategories = true;
  export let narrowImages = false;
  export let offset = 0;
  export let headline;
  export let more;
  export let type = "news";
  export let limit = 20;
  export let ignoredCategories = [];

  let data = [];
  let inProgress = false;

  const items = operationStore(editorialContent, {
    location,
    type,
    offset,
    limit,
    categoryId,
    ignoredCategories,
  });

  query(items);

  items.subscribe((storeObj) => {
    inProgress = storeObj.fetching;
    if (!inProgress && storeObj.data) {
      const newData = [...data, ...storeObj.data.list];
      if (newData > data) {
        data = newData;
      }
    }
  });

  function update() {
    inProgress = true;
    $items.variables.offset = offset + data.length;
    $items.variables.limit = 20;
    $items.reexecute();
  }
</script>

{#if data.length}
  {#if headline}
    <h3 class="text-xl font-medium text-theme-minor-600">{headline}</h3>
  {/if}
  <ul class="my-2 grid grid-cols-1 gap-x-8 sm:grid-cols-2">
    {#each data as item, index}
      <li
        class={clsx(
          "group relative grid min-h-[60px] gap-2 py-2 text-black",
          item.imageThumbUrl ? (narrowImages ? "grid-cols-[60px_1fr]" : "grid-cols-[90px_1fr]") : null,
          (headline || (index != 0 && index != 1)) && "border-t border-theme-gray-400",
        )}
      >
        {#if item.imageThumbUrl}
          <figure>
            <img src={item.imageThumbUrl} alt={item.categoryName} width={narrowImages ? 60 : 90} height="auto" />
          </figure>
        {/if}

        <p class={clsx(item.imageThumbUrl ? "col-start-2" : null, showCategories && item.categoryName ? "block" : "flex items-center")}>
          {#if showCategories && item.categoryName}
            <span class="block text-xs font-medium text-theme-minor-500 group-hocus:text-theme-signal">
              {item.categoryName}
            </span>
          {/if}
          <a href={item.url} class="font-medium leading-5 text-current hocus:text-theme-signal">
            <span class="absolute inset-0" aria-hidden="true" />
            {item.title}
          </a>
        </p>
      </li>
    {/each}
  </ul>
  {#if more && !inProgress}
    <button on:click={update} class="mb-5 inline-block w-full bg-theme-minor-700 px-2 py-1 uppercase text-white hocus:bg-theme-minor-800 lg:w-auto">{more}</button>
  {/if}
{/if}
